
export enum NotificationType {
    AppointmentReminder = 'AppointmentReminder',
}
